import styled from "@emotion/styled";
import { Box, BoxProps, useTheme } from "@mui/material";
import { useScroll } from "framer-motion";
import { useAtom } from "jotai";
import React, { useEffect, useRef } from "react";
import { navTransitionSectionsAtom } from "../atoms";

interface PageSectionBGProps extends BoxProps {
  bgcolor: string;
  paddingTop?: number;
  paddingBottom?: number;
  props?: any;
  id: string;
}

const Background = styled(Box)<{
  bgcolor: string;
  paddingTop?: number;
  paddingBottom?: number;
  theme?: any;
}>`
  background-color: ${({ bgcolor }) => bgcolor};
  padding-top: ${({ paddingTop, theme }) => theme.spacing(paddingTop)};
  padding-bottom: ${({ paddingBottom, theme }) => theme.spacing(paddingBottom)};
`;

const PageSectionBG: React.FC<PageSectionBGProps> = ({
  bgcolor,
  children,
  paddingTop = 10,
  paddingBottom = 10,
  id,
  ...props
}) => {
  const [navTransitionSections, setNavTransitionSections] = useAtom(
    navTransitionSectionsAtom
  );

  const ref = useRef<HTMLDivElement>(null);
  const theme = useTheme();

  let navThemeToSet: "light" | "dark" = "light";
  switch (bgcolor) {
    case theme.palette.primary.main:
      navThemeToSet = "dark";
      break;
    case theme.palette.secondary.main:
      navThemeToSet = "dark";
      break;
    case theme.palette.common.white:
      navThemeToSet = "light";
      break;
    default:
      navThemeToSet = "light";
  }

  const { scrollY } = useScroll();

  useEffect(() => {
    // Set the navTransitionSections atom with the id and ref
    setNavTransitionSections(
      (prev: { [key: string]: HTMLDivElement | null }) =>
        ({
          ...prev,
          [id]: {
            ref: ref.current,
            navTheme: navThemeToSet,
          },
        } as { [key: string]: HTMLDivElement | null })
    );
  }, [id, ref.current, setNavTransitionSections]);

  return (
    <Background
      ref={ref}
      className="page-section"
      data-nav-theme={navThemeToSet}
      bgcolor={bgcolor}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      theme={theme}
      {...props}
      id={id}
    >
      {/* <motion.circle
        cx="50"
        cy="50"
        r="30"
        pathLength="1"
        className="indicator"
        style={{ pathLength: scrollY }}
      /> */}
      {children}
    </Background>
  );
};

export default PageSectionBG;
